webpackJsonp([45],{

/***/ 10:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo3.2054cce.png";

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wxShow),
      expression: "wxShow"
    }],
    staticClass: "wx-load-c",
    staticStyle: {
      "width": "100%",
      "height": "100"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin": "20px",
      "font-size": "30px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "ios-close"
    },
    on: {
      "click": _vm.wxClose
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login_container"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reg-from"
  }, [_vm._m(1), _vm._v(" "), (_vm.op === 0 && _vm.wxBand == false) ? _c('div', {
    staticClass: "from-box",
    class: {
      'op': _vm.op === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sign.phone),
      expression: "sign.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.sign.phone)
    },
    on: {
      "blur": function($event) {
        return _vm.signPhone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sign, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op2 === true
    }
  }, [_vm._v("*请填写正确的手机号")]), _vm._v(" "), (!_vm.dx) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sign.psd),
      expression: "sign.psd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.sign.psd)
    },
    on: {
      "blur": function($event) {
        return _vm.signPsd()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sign, "psd", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.dx) ? _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op4 === true
    }
  }, [_vm._v("*密码错误")]) : _vm._e(), _vm._v(" "), (_vm.dx) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sign.psd),
      expression: "sign.psd"
    }],
    staticClass: "yzm-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.sign.psd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sign, "psd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }],
    staticClass: "get-yzm",
    on: {
      "click": function($event) {
        return _vm.signYzm()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm2))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show2),
      expression: "!show2"
    }],
    staticClass: "get-yzm"
  }, [_vm._v(_vm._s(_vm.count2) + "s")])]) : _vm._e(), _vm._v(" "), (_vm.dx) ? _c('p', {
    staticClass: "from-warning"
  }, [_vm._v("*验证码错误")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "20px"
    }
  }, [(!_vm.dx) ? _c('Checkbox', [_vm._v("记住密码")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "#5C8DDE",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.dxFrom()
      }
    }
  }, [_vm._v(_vm._s(_vm.txt))])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('button', {
    staticClass: "btn-sign",
    on: {
      "click": function($event) {
        return _vm.signIn()
      }
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "display": "none"
    }
  }, [_vm._v("or")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px",
      "color": "#323030",
      "opacity": "0.6",
      "padding": "10px 0"
    }
  }, [_vm._v("第三方登录")]), _vm._v(" "), _c('ul', {
    staticClass: "other-sign",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.wxLoad()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]) : _vm._e(), _vm._v(" "), (_vm.op === 1 && _vm.wxBand == false) ? _c('div', {
    staticClass: "from-box",
    class: {
      'op': _vm.op !== 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.nickName),
      expression: "reg.nickName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入昵称"
    },
    domProps: {
      "value": (_vm.reg.nickName)
    },
    on: {
      "blur": function($event) {
        return _vm.regNC()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "nickName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op1 === true
    }
  }, [_vm._v("*请不要输入特殊字符或者为空")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.phone),
      expression: "reg.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.reg.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op2 === true
    }
  }, [_vm._v("*请填写正确的手机号")]), _vm._v(" "), (_vm.op === 1) ? _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.code),
      expression: "reg.code"
    }],
    staticClass: "yzm-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.reg.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }],
    staticClass: "get-yzm",
    on: {
      "click": function($event) {
        return _vm.getYzm()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm1))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show1),
      expression: "!show1"
    }],
    staticClass: "get-yzm"
  }, [_vm._v(_vm._s(_vm.count1) + "s")])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "from-warning"
  }, [_vm._v("*验证码错误")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reg.psd),
      expression: "reg.psd"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.reg.psd)
    },
    on: {
      "blur": function($event) {
        return _vm.regPsd()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reg, "psd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op4 === true
    }
  }, [_vm._v("*密码格式错误,请输入6-21位字母加数字密码")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "20px",
      "padding-top": "10px"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.agr),
      callback: function($$v) {
        _vm.agr = $$v
      },
      expression: "agr"
    }
  }, [_vm._v("已阅读并接受 "), _c('a', {
    staticStyle: {
      "color": "#5C8DDE"
    },
    attrs: {
      "href": "agreement.html"
    }
  }, [_vm._v("《趣编网服务协议》")]), _c('a', {
    staticStyle: {
      "color": "#5C8DDE"
    },
    attrs: {
      "href": "policy.html"
    }
  }, [_vm._v("《趣编网隐私政策》")])])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px 0 0px 0"
    }
  }, [_c('button', {
    staticClass: "btn-sign",
    on: {
      "click": function($event) {
        return _vm.regist()
      }
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.wxBand) ? _c('div', {
    staticClass: "from-box"
  }, [_c('h2', [_vm._v("绑定趣编网账号")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#424753",
      "text-align": "center",
      "line-height": "20px",
      "margin": "12px 0 35px"
    }
  }, [_vm._v("登录已有账号，与你现在登录的微信绑定。绑定后，可以使用微信账号或手机号码登录。")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.band.phone),
      expression: "band.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.band.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.band, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "from-warning",
    class: {
      'op1': _vm.op2 === true
    }
  }, [_vm._v("*请填写正确的手机号")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.band.code),
      expression: "band.code"
    }],
    staticClass: "yzm-ipt",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.band.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.band, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }],
    staticClass: "get-yzm",
    on: {
      "click": function($event) {
        return _vm.getBandYzm2()
      }
    }
  }, [_vm._v(_vm._s(_vm.yzm3))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show3),
      expression: "!show3"
    }],
    staticClass: "get-yzm"
  }, [_vm._v(_vm._s(_vm.count3) + "s")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "20px 0 20px 0"
    }
  }, [_c('button', {
    staticClass: "btn-sign",
    on: {
      "click": function($event) {
        return _vm.goBand()
      }
    }
  }, [_vm._v("绑定")])])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.regList), function(item, index) {
    return (_vm.cur !== index) ? _c('li', {
      class: {
        'li-active': _vm.cur === index
      },
      staticStyle: {
        "font-size": "16px"
      },
      on: {
        "click": function($event) {
          return _vm.liClick(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('ul', {
    staticStyle: {
      "width": "484px",
      "margin": "155px auto 0"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(12),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "32px",
      "line-height": "90px",
      "font-size": "64px",
      "color": "#FFFFFF",
      "letter-spacing": "5.12px"
    }
  }, [_vm._v("打造视频梦工厂")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "15px",
      "line-height": "50px",
      "font-size": "36px",
      "color": "#FFFFFF",
      "letter-spacing": "4.8px"
    }
  }, [_vm._v("懂视频·更懂你")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "40px 0"
    }
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "170px",
      "margin": "0 auto"
    },
    attrs: {
      "src": __webpack_require__(1253),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })])
}]}

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GetQueryString: function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);return null;
  },
  ImgUpload: function ImgUpload(btn, cb) {
    //上传图片
    var videoPhotoOption = {};
    videoPhotoOption.uploadParentPath = "sd/photo"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = function () {
      cb(videoPhotoOption.fileUrl);
    }; //上传成功回调方法
    videoPhotoOption.fileType = "jpg,jpeg,png"; //文件类型
    videoPhotoOption.maxFileSize = "100mb"; //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  VideoUpload: function VideoUpload(btn, cb) {
    //上传视频
    var videoPhotoOption = {};
    videoPhotoOption.test = 'abc';
    videoPhotoOption.uploadParentPath = "sd/video"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = function () {
      cb(videoPhotoOption.fileUrl);
    }; //上传成功回调方法
    videoPhotoOption.fileType = "mp4"; //文件类型
    videoPhotoOption.maxFileSize = "500mb"; //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  AudioUpload: function AudioUpload(btn, cb) {
    //上传视频
    var videoPhotoOption = {};
    videoPhotoOption.test = 'abc';
    videoPhotoOption.uploadParentPath = "sd/video"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = function () {
      cb(videoPhotoOption.fileUrl);
    }; //上传成功回调方法
    videoPhotoOption.fileType = "mp3,mp4"; //文件类型
    videoPhotoOption.maxFileSize = "500mb"; //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  pdfUpload: function pdfUpload(btn, cb) {
    //上传pdf
    var videoPhotoOption = {};
    videoPhotoOption.uploadParentPath = "sd/pdf"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = function () {
      cb(videoPhotoOption.fileUrl);
    }; //上传成功回调方法
    videoPhotoOption.fileType = "pdf"; //文件类型
    videoPhotoOption.maxFileSize = "100mb"; //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  fileUpload: function fileUpload(btn, cb) {
    //上传文件
    var videoPhotoOption = {};
    videoPhotoOption.uploadParentPath = "sd/photo"; //设置保存的文件夹名称，格式 dir1/dir2
    videoPhotoOption.browse_button = btn; //上传文件按钮的id
    videoPhotoOption.callback = function () {
      console.log(videoPhotoOption);
      cb(videoPhotoOption.fileUrl);
    }; //上传成功回调方法
    videoPhotoOption.fileType = "jpg,jpeg,png,doc,docx"; //文件类型
    videoPhotoOption.maxFileSize = "100mb"; //文件最大限制
    videoPhotoOption.bucketName = "qvbian-web"; //空间名
    videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
    videoPhotoOption.domainName = "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
    UploadDemo.uploader(videoPhotoOption);
  },
  getImgByPdf: function getImgByPdf(el, url) {
    $("#" + el).empty();
    // var url = 'http://qvbian-web.oss-cn-shanghai.aliyuncs.com/contract/sx20180801000005.pdf';
    url = url + "?" + Math.random();

    PDFJS.workerSrc = '/static/pdf/pdf.worker.js';
    PDFJS.getDocument(url).then(function (pdf) {
      var pageSize = pdf.numPages;

      var _loop = function _loop() {
        var canvas = document.createElement('canvas');
        // canvas.id = "pageNum" + i;
        $("#" + el).append(canvas);
        var context = canvas.getContext('2d');
        var scale = 2;
        pdf.getPage(i).then(function (page) {
          var viewport = page.getViewport(scale);
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          canvas.style.width = "100%";
          var renderContext = {
            canvasContext: context,
            viewport: viewport
          };
          page.render(renderContext);
        });
      };

      for (var i = 1; i <= pageSize; i++) {
        _loop();
      }
    });
  }
});

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export post */
/* unused harmony export fetch */
/* unused harmony export get */
/* unused harmony export geter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return indexApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return caseIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiReg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TalentApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return activityApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return publishApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return codeApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return projectApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return infoDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return accountApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return userPageApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return realApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VenueApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EquipmentApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LogoutApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return IP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//引入axios



//服务器切换
var IP = '../qvbian'; // 线上
// const IP = 'http://192.168.1.245:9288/qvbian';  // 测试

// axios 配置
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.timeout = 10000;
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.get['Content-Type'] = 'application/json'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL = IP;

//请求之前处理参数
//添加loading状态
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
  if (config.method === 'post' && config.headers.hasOwnProperty('Content-Type')) {
    config.data = JSON.stringify(config.data);
  } else if (config.method === 'post') {
    config.data = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(config.data);
  } else if (config.method === 'get' && config.headers.hasOwnProperty('Content-Type')) {
    config.data = JSON.stringify(config.data);
  } else if (config.method === 'get') {
    config.data = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(config.data);
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

//统一处理返回状态
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(function (config) {
  if (config.data.status === -1) {
    //未登录暂不统一处理
    localStorage.removeItem('userInfo');
    window.location = 'register.html';
  } else if (config.data.status === 0) {
    // msgError('系统异常！');
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

//post请求头一
function post(url, params) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, params, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

// post请求头二
function fetch(url, params) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, params).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

function get(url, params) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: params }).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

function geter(url, params) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, params, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}

var indexApi = {
  //获取首页banner
  getHomepageBanner: function getHomepageBanner(params) {
    return get('/api/getHomepageBanner', params);
  },

  //获取首页视频案例
  getHomepWorkSample: function getHomepWorkSample(params) {
    return get('/api/getHomepWorkSample', params);
  },

  //获取首页制作人
  getHomepageProducer: function getHomepageProducer(params) {
    return get('/api/getHomepageProducer', params);
  },

  //获取首页展示的演员及模特
  getHomepageModelActor: function getHomepageModelActor(params) {
    return get('/api/getHomepageModelActor', params);
  },

  //获取首页资讯列表
  getHomepageInformation: function getHomepageInformation(params) {
    return get('/api/getHomepageInformation', params);
  },

  //获取首页活动
  getHomepageActivity: function getHomepageActivity(params) {
    return get('/api/getHomepageActivity', params);
  },

  //获取资讯列表
  getInformationByPage: function getInformationByPage(p) {
    return get('/api/getInformationByPage', p);
  },

  //id获取资讯详情
  getInformationDetail: function getInformationDetail(p) {
    return get('/api/getInformationDetail', p);
  },

  //获取首页模块
  getHomepageModule: function getHomepageModule(p) {
    return get('/api/getHomepageModule', p);
  }
};

//案例展示
var caseIndex = {
  //读消息
  apiAccountsetMsgRead: function apiAccountsetMsgRead(p) {
    return get('/api/account/setMsgRead', p);
  },

  //分页获取视频案例
  getWorkSampleByPage: function getWorkSampleByPage(params) {
    return get('/api/getWorkSampleByPage', params);
  },

  //案例详情
  getWorkSampleDetail: function getWorkSampleDetail(params) {
    return get('/api/getWorkSampleDetail', params);
  },

  //发送评论
  postSampleComment: function postSampleComment(params) {
    return fetch('/api/account/postSampleComment', params);
  },

  //客户评论
  postCommentComment: function postCommentComment(p) {
    return fetch('/api/account/postCommentComment', p);
  },

  //获取更多评论
  getSampleCommentByPage: function getSampleCommentByPage(params) {
    return get('/api/getSampleCommentByPage', params);
  },

  //删除评论
  deleteSampleComment: function deleteSampleComment(p) {
    return get('/api/account/deleteSampleComment', p);
  },

  //播放次数
  apiIncreasePlayCount: function apiIncreasePlayCount(params) {
    return get('/api/increasePlayCount', params);
  },

  //点赞
  apiAccountSetLikeForSample: function apiAccountSetLikeForSample(params) {
    return get('/api/account/setLikeForSample', params);
  },

  //邀请
  apiPostConsumerIntention: function apiPostConsumerIntention(params) {
    return post('/api/postConsumerIntention', params);
  },


  //消息列表
  msgList: function msgList(p) {
    return get('/api/account/msgList', p);
  },

  //删除消息
  deleteMsg: function deleteMsg(p) {
    return get('/api/account/deleteMsg', p);
  },

  //制作人收藏列表
  producerKeepList: function producerKeepList(p) {
    return get('/api/account/producerKeepList', p);
  },

  //收藏取消收藏制作人
  producerKeep: function producerKeep(p) {
    return get('/api/account/producerKee', p);
  },

  //视频案例收藏列表
  workSampleKeepList: function workSampleKeepList(p) {
    return get('/api/account/workSampleKeepList', p);
  },

  //收藏案例
  apiAccountWorkSampleKeep: function apiAccountWorkSampleKeep(p) {
    return get('/api/account/workSampleKeep', p);
  },

  //艺人收藏列表
  modelKeepList: function modelKeepList(p) {
    return get('/api/account/modelKeepList', p);
  },

  //收藏取消艺人
  modelKeep: function modelKeep(p) {
    return get('/api/account/modelKeep', p);
  }
};
//登录注册
var apiReg = {
  //
  accountWeixinOpenBind: function accountWeixinOpenBind(p) {
    return get('/api/account/weixinOpenBind', p);
  },

  //微信登录
  apiWeixinOpenLogin: function apiWeixinOpenLogin(p) {
    return get('/api/weixinOpenLogin', p);
  },

  //绑定
  apiWeixinOpenBind: function apiWeixinOpenBind(p) {
    return get('/api/weixinOpenBind', p);
  },
  apiWeixinOpenUnbind: function apiWeixinOpenUnbind(p) {
    return get('api/account/weixinOpenUnbind', p);
  },

  //注册
  register: function register(params) {
    return fetch('/api/register', params);
  },

  //注册短信
  apiGetSmsCode_3: function apiGetSmsCode_3(params) {
    return get('/api/getSmsCode_3', params);
  },

  //登录
  apiLogin: function apiLogin(params) {
    return fetch('/api/login', params);
  },
  apiGetSmsCode_4: function apiGetSmsCode_4(params) {
    return get('/api/getSmsCode_4', params);
  },

  //退出
  apiLogout: function apiLogout(params) {
    return fetch('/api/logout', params);
  },

  //修改密码
  apiAccountChangePassword: function apiAccountChangePassword(params) {
    return fetch('/api/account/changePassword', params);
  },

  //按短信修改密码
  apiResetPassword: function apiResetPassword(params) {
    return fetch('/api/resetPassword', params);
  },

  //发送邮箱验证
  apiAccountSendBindMail: function apiAccountSendBindMail(params) {
    return get('/api/account/sendBindMail', params);
  },

  //绑定邮箱
  apiVerifyMail: function apiVerifyMail(params) {
    return get('/api/verifyMail', params);
  },

  //查询钱包数据
  apiAccountGetAccountMoney: function apiAccountGetAccountMoney(params) {
    return get('/api/account/getAccountMoney', params);
  },

  //设置取款密码
  apiAccountDrawPwdSet: function apiAccountDrawPwdSet(params) {
    return fetch('/api/account/drawPwdSet', params);
  },

  //添加银行卡
  apiAccountBankCardBind: function apiAccountBankCardBind(params) {
    return fetch('/api/account/bankCardBind', params);
  },

  //删除银行卡
  apiAccountBankCardDelete: function apiAccountBankCardDelete(p) {
    return fetch('/api/account/bankCardDelete', p);
  },

  //申请提现
  apiAccountDrawMoney: function apiAccountDrawMoney(params) {
    return fetch('/api/account/drawMoney', params);
  },

  //交易明细
  apiAccountGetMoneyExchangeList: function apiAccountGetMoneyExchangeList(params) {
    return get('/api/account/getMoneyExchangeList', params);
  },

  //钱包列表
  apiGetDrawMoneyList: function apiGetDrawMoneyList(p) {
    return get('/api/account/getDrawMoneyList', p);
  }
};

var TalentApi = {
  //制作团队和制作人
  getProducerByPage: function getProducerByPage(params) {
    return get('/api/getProducerByPage', params);
  },

  //演员和模特
  getModelActorList: function getModelActorList(params) {
    return get('/api/getModelActorList', params);
  },

  //演员和模特详情
  getModelActorDetail: function getModelActorDetail(params) {
    return get('/api/getModelActorDetail', params);
  },

  //收藏演员和模特
  modelKeep: function modelKeep(params) {
    return get('/api/account/modelKeep', params);
  },

  //获取红人详情
  getFavouriteDetail: function getFavouriteDetail(params) {
    return get('/api/account/getFavouriteDetail', params);
  },

  //更新美图
  updatePhotos: function updatePhotos(params) {
    return fetch('/api/account/updatePhotos', params);
  },

  //更新资料
  postFavouriteInfo: function postFavouriteInfo(params) {
    return post('/api/account/postFavouriteInfo', params);
  }
};

var activityApi = {
  //活动
  getActivityByPage: function getActivityByPage(params) {
    return get('/api/getActivityByPage', params);
  }
};

var publishApi = {
  //发布意向单
  postConsumerIntention: function postConsumerIntention(params) {
    return post('/api/postConsumerIntention', params);
  },
  verifyAccountExistance: function verifyAccountExistance(params) {
    return get('/api/verifyAccountExistance', params);
  }
};

var codeApi = {
  //获取验证码
  apiGetSmsCode_1: function apiGetSmsCode_1(params) {
    return get('/api/getSmsCode_1', params);
  },
  apiGetSmsCode_2: function apiGetSmsCode_2(params) {
    return get('/api/getSmsCode_2', params);
  },
  apiGetSmsCode_3: function apiGetSmsCode_3(params) {
    return get('/api/getSmsCode_3', params);
  },
  apiGetSmsCode_4: function apiGetSmsCode_4(params) {
    return get('/api/getSmsCode_4', params);
  },
  apiAccountVerifyFormalMobileSms4: function apiAccountVerifyFormalMobileSms4(params) {
    return fetch('/api/account/verifyFormalMobileSms4', params);
  }
};

var accountApi = {
  apiAccountVerifyPhoneValid: function apiAccountVerifyPhoneValid(params) {
    return fetch('/api/account/verifyPhoneValid', params);
  },
  apiAccountChangeMobile: function apiAccountChangeMobile(params) {
    return fetch('/api/account/changeMobile', params);
  },

  //查找个人信息
  apiAccountGetDetail: function apiAccountGetDetail(params) {
    return get('/api/account/getDetail', params);
  },
  apiAccountEditAccount: function apiAccountEditAccount(params) {
    return post('/api/account/editAccount', params);
  }
};

var projectApi = {
  //我的项目
  getConsumerIntentionList: function getConsumerIntentionList(params) {
    return get('/api/customer/getConsumerIntentionList', params);
  },

  //获取详情
  getConsumerIntentionDetail: function getConsumerIntentionDetail(params) {
    return get('/api/customer/getConsumerIntentionDetail', params);
  },

  //签署合同
  signContract: function signContract(params) {
    return get('/api/customer/signContract', params);
  },

  //准备支付
  prePay: function prePay(params) {
    return fetch('/api/customer/prePay', params);
  },

  //接受策划案
  acceptPlot: function acceptPlot(params) {
    return get('/api/customer/acceptPlot', params);
  },

  //申请修改
  modifyRequest: function modifyRequest(params) {
    return get('/api/customer/modifyRequest', params);
  },

  //选择版本
  choseVideoVersion: function choseVideoVersion(params) {
    return get('/api/customer/choseVideoVersion', params);
  },
  signAttachment: function signAttachment(params) {
    return get('/api/customer/signAttachment', params);
  },
  confirmScreen: function confirmScreen(params) {
    return get('/api/customer/confirmScreen', params);
  },


  /**--制片列表 详情--****/
  //制片list
  apiProducerGetConsumerIntentionList: function apiProducerGetConsumerIntentionList(params) {
    return get('/api/producer/getConsumerIntentionList', params);
  },

  //制片详情
  apiProducerGetConsumerIntentionDetail: function apiProducerGetConsumerIntentionDetail(params) {
    return get('/api/producer/getConsumerIntentionDetail', params);
  },

  //按角色查询制作人列表
  apiProducerGetRoleInfoList: function apiProducerGetRoleInfoList(params) {
    return get('/api/producer/getRoleInfoList', params);
  },

  //提交报价清单
  apiProducerPostPriceAndRole: function apiProducerPostPriceAndRole(params) {
    return post('/api/producer/postPriceAndRole', params);
  },

  //签署合同
  apiProducerSignContrac: function apiProducerSignContrac(params) {
    return get('/api/producer/signContract', params);
  },

  //接受项目
  apiProducerConfirm: function apiProducerConfirm(params) {
    return get('/api/producer/producerConfirm', params);
  }
};

var infoDetailApi = {
  //咨询详情
  getInformationDetail: function getInformationDetail(params) {
    return get('/api/getInformationDetail', params);
  }
};

var userPageApi = {
  //制作人主页
  getProducerByPage: function getProducerByPage(params) {
    return get('/api/getProducerByPage', params);
  },

  //置顶案例
  getTopSample: function getTopSample(params) {
    return get('/api/getTopSample', params);
  },

  //获取制作人
  getProducerDetail: function getProducerDetail(params) {
    return get('/api/getProducerDetail', params);
  },

  //上传背景
  accountangeBackground: function accountangeBackground(params) {
    return fetch('/api/account/changeBackground', params);
  },

  //发布作品
  apiccountPostWorkSample: function apiccountPostWorkSample(params) {
    return post('/api/account/postWorkSample', params);
  },

  //x修改作品
  apiAccountGetWorkSample: function apiAccountGetWorkSample(params) {
    return get('/api/account/getWorkSample', params);
  },

  //删除作品
  apiAccountDeleteWorkSample: function apiAccountDeleteWorkSample(params) {
    return get('/api/account/deleteWorkSample', params);
  },

  //设置置顶案例
  apiAccountSetTopWorkSample: function apiAccountSetTopWorkSample(params) {
    return get('/api/account/setTopWorkSample', params);
  },

  //制作人收藏
  apiAccountProducerKeep: function apiAccountProducerKeep(params) {
    return get('/api/account/producerKeep', params);
  },

  //获取认证标签
  getProducerTagAuth: function getProducerTagAuth(params) {
    return get('/api/account/getProducerTagAuth', params);
  },

  //提交认证标签
  postProducerTagAuth: function postProducerTagAuth(params) {
    return post('/api/account/postProducerTagAuth', params);
  }
};

var realApi = {
  //提交制作人认证
  postProducerAuth: function postProducerAuth(params) {
    return post('/api/account/postProducerAuth', params);
  },

  //查询制作人认证信息
  getProducerAuth: function getProducerAuth(params) {
    return get('/api/account/getProducerAuth', params);
  }
};

var VenueApi = {
  //分页获取场地
  getVenueByPage: function getVenueByPage(params) {
    return get('/api/getVenueByPage', params);
  },

  //更新场地
  postVenue: function postVenue(params) {
    return post('/api/account/postVenue', params);
  },

  //删除场地
  deleteVenue: function deleteVenue(params) {
    return get('/api/account/deleteVenue', params);
  },

  //获取场地内容
  getVenueDetail: function getVenueDetail(params) {
    return get('/api/getVenueDetail', params);
  },

  //收藏场地内容
  venueKeep: function venueKeep(params) {
    return get('/api/account/venueKeep', params);
  },

  //收藏场地列表
  venueKeepList: function venueKeepList(params) {
    return get('/api/account/venueKeepList', params);
  }
};

var EquipmentApi = {
  //分页获取器材
  getEquipmentByPage: function getEquipmentByPage(params) {
    return get('/api/getEquipmentByPage', params);
  },

  //更新场地
  postEquipment: function postEquipment(params) {
    return post('/api/account/postEquipment', params);
  },

  //删除器材
  deleteEquipment: function deleteEquipment(params) {
    return get('/api/account/deleteEquipment', params);
  },

  //获取器材内容
  getEquipmentDetail: function getEquipmentDetail(params) {
    return get('/api/getEquipmentDetail', params);
  },

  //收藏器材内容
  equipmentKeep: function equipmentKeep(params) {
    return get('/api/account/equipmentKeep', params);
  },

  //收藏器材列表
  equipmentKeepList: function equipmentKeepList(params) {
    return get('/api/account/equipmentKeepList', params);
  }
};
var LogoutApi = {
  //注销检查
  checkHasProject: function checkHasProject(params) {
    return fetch('/api/account/checkHasProject', params);
  },

  //注销验证码
  verifySignOff: function verifySignOff(params) {
    return fetch('/api/account/verifySignOff', params);
  },

  //注销验证码
  signOff: function signOff(params) {
    return fetch('/api/account/signOff', params);
  }
};



/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1272),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c3307b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_js_common__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util_js__ = __webpack_require__(29);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "register",
  data: function data() {
    return {
      wxBand: false,
      wxShow: false,
      regList: [{
        name: "已有账号？去登录",
        value: "sign"
      }, {
        name: "没有账号？去注册",
        value: "reg"
      }],
      cur: 0,
      op: 0,
      op1: false,
      op2: false,
      op4: false,
      txt: "短信快捷登录",
      dx: false,
      yzm2: "获取验证码",
      yzm1: "获取验证码",
      yzm3: "获取验证码",
      count1: "",
      count2: "",
      count3: "",
      timer1: null,
      timer2: null,
      timer3: null,
      show1: true,
      show2: true,
      show3: true,
      reg: {},
      agr: false,
      sign: {},
      type: 1,
      band: {
        phone: '',
        code: ''
      }
    };
  },

  methods: _defineProperty({
    wxClose: function wxClose() {
      this.wxShow = false;
      location.reload();
    },
    wxLoad: function wxLoad() {
      this.wxShow = true;
    },
    liClick: function liClick(index) {
      this.cur = index;
      console.log(this.cur);
      if (this.cur == 1) {
        this.op = 1;
        this.op1 = false;
        this.op2 = false;
        this.op4 = false;
        this.wxBand = false;
      } else {
        this.op = 0;
        this.op1 = false;
        this.op2 = false;
        this.op4 = false;
      }
    },
    dxFrom: function dxFrom() {
      if (this.dx == false) {
        this.dx = true;
        this.txt = "账号密码登录";
        this.op = 0;
        this.type = 2;
        this.sign.psd = "";
      } else {
        this.dx = false;
        this.txt = "短信快捷登录";
        this.type = 1;
        this.sign.psd = "";
      }
    },

    //验证昵称
    regNC: function regNC() {
      var regs = /^[\w\u4e00-\u9fa5]+$/gi;
      if (this.reg.nickName === undefined) {
        this.op1 = true;
      } else {
        var r = this.reg.nickName.match(regs);
        if (r == null) {
          this.op1 = true;
        } else {
          this.op1 = false;
        }
      }
    },

    //验证手机号
    regPhone: function regPhone() {},
    signPhone: function signPhone() {
      var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      if (this.sign.phone === undefined) {
        this.op2 = true;
      } else {
        var r = this.sign.phone.match(regs);
        if (r == null) {
          this.op2 = true;
        } else {
          this.op2 = false;
        }
      }
    },

    //regYzm
    regYzm: function regYzm() {},
    signYzm: function signYzm() {},

    //验证密码
    regPsd: function regPsd() {
      var regs = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;
      if (this.reg.psd === undefined) {
        this.op4 = true;
      } else {
        var r = this.reg.psd.match(regs);
        if (r == null) {
          this.op4 = true;
        } else {
          this.op4 = false;
        }
      }
    },
    signPsd: function signPsd() {
      var regs = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;
      if (this.sign.psd === undefined) {
        this.op4 = true;
      } else {
        var r = this.sign.psd.match(regs);
        if (r == null) {
          this.op4 = true;
        } else {
          this.op4 = false;
        }
      }
    },

    //注册
    regist: function regist() {
      var _this = this;

      if (this.reg.nickName === undefined || this.op1 !== false) {
        this.op1 = true;
      }
      if (this.reg.phone === undefined || this.op2 !== false) {
        this.op2 = true;
      }
      // if(this.reg.code === undefined || this.op3 !== false){
      //   this.op3 = true;
      // }
      if (this.reg.psd === undefined || this.op4 !== false) {
        this.op4 = true;
      }
      if (!this.agr) {
        msgError("请认真阅读并勾选已阅读《趣编网用户协议》、《趣编网隐私政策》！");
        return;
      }
      var pam = {
        phone: this.reg.phone,
        code: this.reg.code,
        password: this.reg.psd,
        nickName: this.reg.nickName
      };
      if (this.op1 === false && this.op2 === false && this.op4 === false && this.agr === true) {
        __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].register(pam).then(function (data) {
          if (data.status === 1) {
            // window.location.href = 'index.html';
            localStorage.setItem("userInfo", JSON.stringify(data));
            _this.jump();
          } else {
            msgError(data.message);
          }
        });
      }
    },

    //登录
    signIn: function signIn() {
      var _this2 = this;

      this.op4 = false;
      if (this.sign.phone === undefined || this.op2 !== false) {
        this.op2 = true;
      }
      if (this.sign.psd === undefined || this.op4 !== false) {
        // this.op3 = true;
        this.op4 = true;
      }
      var pam = {
        phone: this.sign.phone,
        type: this.type,
        pass: this.sign.psd
      };
      if (this.op2 === false && this.op4 === false) {
        __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].apiLogin(pam).then(function (data) {
          if (data.status === 1) {
            console.log(data);
            localStorage.setItem("userInfo", JSON.stringify(data));
            _this2.jump();
          } else {
            msgError(data.message);
          }
        });
      }
    },

    //判断跳转
    jump: function jump() {
      var prevLink = document.referrer;
      var pathname = document.referrer.indexOf('register.html');

      if (__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.trim(prevLink) == "" || pathname != -1) {
        location.href = "index.html";
      } else {
        location.href = prevLink;
      }
    },
    getBandYzm2: function getBandYzm2() {
      var _this3 = this;

      if (this.band.phone === undefined) {
        this.op2 = true;
      } else {
        //发送前验证手机格式
        var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
        var r = this.band.phone.match(regs);
        if (r == null) {
          msgError("号码不正确！");
          return;
        }
        var pam = {
          phone: this.band.phone
        };
        __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].apiGetSmsCode_4(pam).then(function (data) {
          if (data.status == 1) {
            msgSuccess("请注意查收验证码！");
            var TIME_COUNT3 = 59;
            if (!_this3.timer3) {
              _this3.count3 = TIME_COUNT3;
              _this3.show3 = false;
              _this3.timer3 = setInterval(function () {
                if (_this3.count3 > 0 && _this3.count3 <= TIME_COUNT3) {
                  _this3.count3--;
                } else {
                  _this3.show3 = true;
                  clearInterval(_this3.timer3);
                  _this3.timer3 = null;
                }
              }, 1000);
            }
          } else if (data.status == 0) {
            msgError(data.message);
          }
        });
      }
    },
    goBand: function goBand() {
      var pam = {
        code: this.band.code,
        phone: this.band.phone
      };
      __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].apiWeixinOpenBind(pam).then(function (data) {
        console.log(data);
        if (data.status == 1) {
          location.href = "index.html";
          localStorage.setItem("userInfo", JSON.stringify(data));
          __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].apiWeixinOpenLogin().then();
        } else {
          msgError(data.message);
        }
      });
    },

    //get验证码
    getYzm: function getYzm() {
      var _this4 = this;

      if (this.reg.phone === undefined) {
        this.op2 = true;
      } else {
        //发送前验证手机格式
        var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
        var r = this.reg.phone.match(regs);
        if (r == null) {
          msgError("号码不正确！");
          return;
        }
        var pam = {
          phone: this.reg.phone
        };
        __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].apiGetSmsCode_3(pam).then(function (data) {
          if (data.status == 1) {
            msgSuccess("请注意查收验证码！");
            var TIME_COUNT1 = 59;
            if (!_this4.timer1) {
              _this4.count1 = TIME_COUNT1;
              _this4.show1 = false;
              _this4.timer1 = setInterval(function () {
                if (_this4.count1 > 0 && _this4.count1 <= TIME_COUNT1) {
                  _this4.count1--;
                } else {
                  _this4.show1 = true;
                  clearInterval(_this4.timer);
                  _this4.timer1 = null;
                }
              }, 1000);
            }
          } else if (data.status == 0) {
            msgError(data.message);
          }
        });
      }
    }
  }, "signYzm", function signYzm() {
    var _this5 = this;

    if (this.sign.phone === undefined) {
      this.op2 = true;
    } else {
      //发送前验证手机格式
      var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      var r = this.sign.phone.match(regs);
      if (r == null) {
        msgError("号码不正确！");
        return;
      }
      var pam = {
        phone: this.sign.phone
      };
      __WEBPACK_IMPORTED_MODULE_2__fetch_api_js__["a" /* apiReg */].apiGetSmsCode_4(pam).then(function (data) {
        if (data.status == 1) {
          msgSuccess("请注意查收验证码！");
          var TIME_COUNT2 = 59;
          if (!_this5.timer2) {
            _this5.count2 = TIME_COUNT2;
            _this5.show2 = false;
            _this5.timer = setInterval(function () {
              if (_this5.count2 > 0 && _this5.count2 <= TIME_COUNT2) {
                _this5.count2--;
              } else {
                _this5.show2 = true;
                clearInterval(_this5.timer2);
                _this5.timer2 = null;
              }
            }, 1000);
          }
        } else {
          msgError(data.message);
        }
      });
    }
  }),
  mounted: function mounted() {
    var obj = new WxLogin({
      id: "login_container",
      appid: "wx0f66844ed18e08da",
      scope: "snsapi_login",
      style: "white",
      redirect_uri: "https://www.qvbian.com/qvbian/api/wxOpenRedirect"
    });
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_3__util_util_js__["a" /* default */].GetQueryString("mode")) {
      this.wxBand = true;
    }
    // if(Util.GetQueryString("mode")){
    //   if(localStorage.getItem("userInfo")){
    //     apiReg.accountWeixinOpenBind().then(data=>{
    //       if(data.status == 1){
    //         location.href = "account.html";
    //       }
    //     });
    //   }else{
    //     location.href = "register.html?mode='true'";
    //   }
    // }
  }
});

/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_vue__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__register_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#register',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__register_vue___default.a }
});

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters_filters__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_common_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_common_css__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);

//注册全局过滤器
for (var key in __WEBPACK_IMPORTED_MODULE_4__filters_filters__["a" /* default */]) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_4__filters_filters__["a" /* default */][key]);
}

//弹框提示
window.alert = function (msg) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Modal.info({
    title: '提示',
    content: msg
  });
};
window.confirm = function (msg, cb) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Modal.confirm({
    title: '提示',
    content: msg,
    onOk: function onOk() {
      cb(true);
    },
    onCancel: function onCancel() {
      cb(false);
    }
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Message.config({
  top: 80,
  duration: 3
});
window.msgSuccess = function (msg) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Message.success(msg);
};
window.msgError = function (msg) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Message.error(msg);
};
window.msgWarning = function (msg) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$Message.warning(msg);
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$resize = function (w, h) {
  return '?x-oss-process=image/resize,w_' + w + ',h_' + h;
};

__WEBPACK_IMPORTED_MODULE_3_jquery___default()(function () {
  var cp = window.location.pathname;
  var d = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(document);

  if (cp == "/" || cp == "/index.html" || cp == "/indexIE.html") {
    var b = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".banner");
    var h = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".header");
    var e = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".shoot");
    var z = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".zebra");
    var a = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".advert");
    var cv = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".create-video");

    h.removeClass("black");
    cv.removeClass("visi");

    window.onscroll = function () {
      var dh = d.scrollTop();
      var bh = b.offset().top + b.height();
      var eh = e.offset().top + e.height();

      //导航菜单
      if (dh >= bh) {
        h.addClass("black");
        cv.removeClass("visi");
      } else {
        h.removeClass("black");
        cv.addClass("visi");
      }

      //估价器
      if (dh >= eh) {
        z.removeClass("hide");
        a.removeClass("hide");
      } else {
        z.addClass("hide");
        a.addClass("hide");
      }

      //加载动画
      scrollfun();
    };
  }
});

function scrollfun() {
  //服务
  scrollacro('.service', '.service dl', 'acro-scale-visible');

  //案例
  var bigel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.case .list-big .item');
  bigel.each(function (i, e) {
    scrollacro('.case .list-big', bigel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  var cel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.case .list .item');
  cel.each(function (i, e) {
    scrollacro('.case .list', cel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //制作人
  var pel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.producer .list .item');
  pel.each(function (i, e) {
    scrollacro('.producer .list', pel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //演员
  var ael = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.artist .list .item');
  ael.each(function (i, e) {
    scrollacro('.artist .list', ael[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //新闻
  var nel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.news .list .item');
  nel.each(function (i, e) {
    scrollacro('.news .list', nel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //品牌
  var bel = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.brand ul li');
  bel.each(function (i, e) {
    if (i < 5) {
      scrollacro('.brand ul', e, 'acro-visible acro-delay1');
    } else if (i < 10) {
      scrollacro('.brand ul', e, 'acro-visible acro-delay2');
    } else if (i < 15) {
      scrollacro('.brand ul', e, 'acro-visible acro-delay3');
    } else {
      scrollacro('.brand ul', e, 'acro-visible acro-delay4');
    }
  });
}

function scrollacro(target, element, cssname) {
  var b, c, d;

  if (element == '') {
    element = target;
  }

  d = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(target).offset().top;
  b = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).scrollTop();
  c = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(window).height();

  if (c / 1.5 + b > d) {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).addClass(cssname);
  }
}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ft = {
  venueLocal: function venueLocal(val) {
    var str = val.split(',');
    return str[1] + "-" + str[2];
  },
  char10: function char10(val) {
    if (val.length < 20) {
      return val;
    }
    return val.substr(0, 20) + "...";
  },
  char50: function char50(val) {
    if (val.length < 50) {
      return val;
    }
    return val.substr(0, 50) + "...";
  },
  role: function role(val) {
    var array = val.split(",");

    if (array.length > 3) {
      array.length = 3;
      return array.join(" / ");
    } else {
      return array.join(" / ");
    }
  },
  formatDate: function formatDate(val) {
    if (val == null) {
      return '-';
    }
    if (val == '未填写') {
      return val;
    }
    var date = new Date(val);
    var y = 1900 + date.getYear();
    var m = "0" + (date.getMonth() + 1);
    var d = "0" + date.getDate();
    return y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length);
  },
  formatDateDot: function formatDateDot(val) {
    var date = new Date(val);
    var y = 1900 + date.getYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    return y + "." + m + "." + d;
  },
  teamSize: function teamSize(val) {
    if (val == 1) {
      return '10人以内';
    } else if (val == 2) {
      return '10-50人';
    } else if (val == 3) {
      return '50人以上';
    }
  },
  unit: function unit(val) {
    if (val <= 9999) {
      return parseInt(val);
    } else if (val <= 99999999) {
      return parseInt(val / 10000) + '万+';
    } else {
      return parseInt(val / 100000000) + '亿+';
    }
  },
  budget: function budget(val) {
    if (val == 1) {
      return "5000以内";
    } else if (val == 2) {
      return "5000-10000";
    } else if (val == 3) {
      return "10000-50000";
    } else if (val == 4) {
      return "50000-100000";
    } else {
      return "100000以上";
    }
  },
  length: function length(val) {
    if (val == 1) {
      return "30秒以内";
    } else if (val == 2) {
      return "30-60秒";
    } else if (val == 3) {
      return "60-120秒";
    } else {
      return "120秒以上";
    }
  },
  bankCard: function bankCard(val) {
    var strlen = val.length;
    return val.replace(/^(.{0})(?:\d+)(.{4})$/, "$1****-****-****-***-$2");
  },
  phoneCard: function phoneCard(val) {
    var strlen = val.length;
    return val.replace(/^(.{3})(?:\d+)(.{3})$/, "$1******$2");
  },
  ppaType: function ppaType(val) {
    var str;
    if (val < 4) {
      str = "待沟通";
    } else if (val < 5) {
      str = "待签署";
    } else if (val == 5) {
      str = "待支付策划费";
    } else if (val > 5 && val < 10) {
      str = "策划中";
    } else if (val == 10) {
      str = "待确认策划方案";
    } else if (val == 11) {
      str = "待支付拍摄费";
    } else if (val > 11 && val < 21) {
      str = "拍摄中";
    } else if (val == 21) {
      str = "待支付尾款";
    } else if (val == 22) {
      str = "已完成";
    } else if (val == 23) {
      str = "已关闭";
    }
    return str;
  },
  version: function version(val) {
    var str;
    switch (val) {
      case 0:
        str = "第一版";
        break;
      case 1:
        str = "第二版";
        break;
      case 2:
        str = "第三版";
        break;
      case 3:
        str = "第四版";
        break;
      default:
        str = "请选择版本";
        break;
    }
    return str;
  },
  yuan: function yuan(val) {
    return (val / 100).toFixed(2);
  },
  ppbType: function ppbType(val) {
    var str;
    if (val < 14) {
      str = "待加入";
    } else if (val > 13 && val < 22) {
      str = "进行中";
    } else if (val == 22) {
      str = "已完成";
    } else if (val == 23) {
      str = "已关闭";
    }
    return str;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ft);

/***/ })

},[683]);


// WEBPACK FOOTER //
// static/js/register.6d134e4ea089da51588b.js